export default {
  UPDATE_ODDS_RULES: 'UPDATE_ODDS_RULES',
  UPDATE_FUTURE: 'UPDATE_FUTURE',
  UPDATE_BETSLIP_TICKET: 'UPDATE_BETSLIP_TICKET',
  SET_UPCOMING_EVENTS: 'SET_UPCOMING_EVENTS',
  SET_MAX_FUTURE_ROUNDS: 'SET_MAX_FUTURE_ROUNDS',
  SET_RECONNECT_STATE: 'SET_RECONNECT_STATE',
  SET_SOCKET_REINIT_IN_PROGRESS: 'SET_SOCKET_REINIT_IN_PROGRESS',
};
